// import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ModalRestorePassword({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();

    // useEffect(() => {
    //     iniciar();
    // }, [formData]);

    // const iniciar = async () => {
    //     try {
    //         console.log('formData');
    //         console.log(formData);
    //     } catch (err) {
    //         console.log('iniciar err');
    //         console.log(err);
    //     }
    // };

    const charLimits = {
        password: 16,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            let message = "";
            if (String(formData.password).trim().length === 0) {
                message = message + t("alert_must_enter_password") + '\n';
            }
            if (message.length > 0) {
                alert(message);
                return;
            }
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            password: "",
        });
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>

                        {/* Inputs */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_password")}</label>
                            <input
                                name="password"
                                value={formData.password}
                                onChange={handleInputChange}
                                placeholder={t("label_enter_password")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.password?.length}/{charLimits.password}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
